import { render, staticRenderFns } from "./chooseaciver.vue?vue&type=template&id=ab070d0a&scoped=true"
import script from "./chooseaciver.vue?vue&type=script&lang=js"
export * from "./chooseaciver.vue?vue&type=script&lang=js"
import style0 from "./chooseaciver.vue?vue&type=style&index=0&id=ab070d0a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../../../../../../opt/build-cache/yunying/node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ab070d0a",
  null
  
)

export default component.exports